export const arraySum = (values) => values.reduce((acc, value) => acc + value, 0);
